import React from "react";
import Navbar from "../Navbar";
import { NavLink } from "react-router-dom";
import image from "../../assets/LOGO 1 B.png";
import styled from "styled-components";

const Header = () => {
  return (
    <MainHeader>
      <NavLink to="/">
        <img src={image} alt="NOT FIND" className="logo" />
      </NavLink>
      <Navbar />
    </MainHeader>
  );
};
const MainHeader = styled.header`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 72%;
  height: 6rem;
  background: #ffffff;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4.8rem;
  border-radius: 14px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 780px) {
    top: 0px; /* Aur neeche adjust */
    width: 100%; /* Full width ke close */
    height: 4rem; /* Height thodi kam */
    position: relative;
    padding: 0 1.5rem;
  }

  .logo {
    height: 65px;

    @media (max-width: 900px) {
      height: 50px;
    }

    @media (max-width: 600px) {
      height: 40px;
    }
  }
`;

export default Header;
